import { MessageType } from 'core/hooks/useIframeMessageListener';
import { AstralWalletIFrameMessage } from '../constants';

export const astralWalletPostMessageToParent = (
  message: MessageType<AstralWalletIFrameMessage>,
) => {
  window.parent.postMessage(message, '*');
};
